import React, { useEffect, useState } from 'react';
import './ReviewList.css';
import user from '../../assets/user.png';
import { AiFillStar, AiOutlineStar } from "react-icons/ai";
import { getWithoutTokenAPI } from '../../util/Api';
import { useSelector } from 'react-redux';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Review = ({ name, time, text, rating, image }) => (
    <div className="review-item">
        <div className="review-header">
            <div className="avatar-wrapper">
                {image ? (
                    <img src={image} alt={name} className="avatar" />
                ) : (
                    <div className="default-avatar" />
                )}
            </div>
            <div className="review-info">
                <div className="reviewer-name">{name}</div>
                <div className="stars">
                    {[1, 2, 3, 4, 5].map((i) =>
                        i <= rating ? (
                            <AiFillStar key={i} className="star filled" />
                        ) : (
                            <AiOutlineStar key={i} className="star empty" />
                        )
                    )}
                </div>
            </div>
            <div className="review-time">{time}</div>
        </div>
        <div className="review-text">{text}</div>
        <div className="review-divider"></div>
    </div>
);

const ReviewList = ({ productId }) => {
    const [reviewsData, setReviewsData] = useState([]);
    const [visibleCount, setVisibleCount] = useState(4);
    const accessToken = useSelector((state) => state.auth?.auth?.access_token);

    useEffect(() => {
        const fetchReviews = async () => {
            try {
                const res = await getWithoutTokenAPI('/review/find-all');

                if (!res.error) {
                    const data = res.data.reviews || [];
                    // Filter reviews for the specific product
                    const productReviews = data.filter(review => 
                        review.product_id?._id === productId
                    );
                    
                    const formatted = productReviews.map(r => ({
                        name: r.user_id?.name || 'Anonymous',
                        time: new Date(r.createdAt).toLocaleString(),
                        text: r.review,
                        rating: r.rating,
                        image: r.user_id?.profile_image || user
                    }));
                    setReviewsData(formatted);
                } else {
                    console.error('Failed to fetch reviews:', res.error);
                }
            } catch (error) {
                console.error('Error fetching reviews:', error);
            }
        };

        if (productId) {
            fetchReviews();
        }
    }, [productId]);

    const handleLoadMore = () => {
        setVisibleCount(reviewsData.length);
        toast.info("Showing all reviews", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
        });
    };

    const visibleReviews = reviewsData.slice(0, visibleCount);

    return (
        <>
            <div className="review-list">
                {visibleReviews.length > 0 ? (
                    <>
                        {visibleReviews.map((review, index) => (
                            <Review key={index} {...review} />
                        ))}
                        {visibleCount < reviewsData.length && (
                            <button className='comment-btn' onClick={handleLoadMore}>
                                Load More
                            </button>
                        )}
                    </>
                ) : (
                    <div className="no-reviews">No reviews yet for this product</div>
                )}
            </div>
        </>
    );
};

export default ReviewList;
